const BASE_URL = 'http://43.205.42.216:8000'
// Auth
export const LOGIN_SCAN_CENTER = `${BASE_URL}/scan-center/login/`

// //Common
export const UPLOAD_IMAGE = `${BASE_URL}/common/upload-file/`
// Manage Scan Center
export const SCAN_CATEGORY_LISTING = `${BASE_URL}/scan-center/scan-category/`
export const ADD_SCAN_CATEGORY = `${BASE_URL}/scan-center/scan-category/add-scan-category/`
export const UPDATE_SCAN_CATEGORY = `${BASE_URL}/scan-center/scan-category/update-scan-category/`
export const DELETE_SCAN_CATEGORY = `${BASE_URL}/scan-center/scan-category/delete-scan-category/`

// Test Scan Center
export const SCAN_TEST_LISTING = `${BASE_URL}/scan-center/scans/`
export const ADD_SCAN_TEST = `${BASE_URL}/scan-center/add-scan/`
export const UPDATE_SCAN_TEST = `${BASE_URL}/scan-center/update-scan/`
export const DELETE_SCAN_TEST = `${BASE_URL}/scan-center/delete-scan/`
